<span [ngStyle]="{'max-width.px': maxWidth }" class="text-semibold">{{ text$ | async }}</span>
